"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var formatTime = function formatTime(time) {
  var seconds = time / 1000;
  return "".concat(seconds.toFixed(1));
};

var CountDown = function CountDown(_ref) {
  var time = _ref.time,
      _ref$updateInterval = _ref.updateInterval,
      updateInterval = _ref$updateInterval === void 0 ? 100 : _ref$updateInterval;

  var _useState = (0, _react.useState)(time),
      _useState2 = _slicedToArray(_useState, 2),
      timeRemaining = _useState2[0],
      setTimeRemaining = _useState2[1];

  var timeRemainingRef = (0, _react.useRef)(time);
  var isMountedRef = (0, _react.useRef)(true);
  var setIntervalRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    // attach setInterval to update time remaining
    setIntervalRef.current = window.setInterval(function () {
      // if there is time remaining, decrement by updateInterval
      var nextTimeRemaining = timeRemainingRef.current - updateInterval;

      if (nextTimeRemaining >= 0 && isMountedRef.current === true) {
        setTimeRemaining(timeRemainingRef.current - updateInterval);
      }
    }, updateInterval);
    return function () {
      isMountedRef.current = false; // clear the interval timer

      if (setIntervalRef.current !== null) {
        window.clearInterval(setIntervalRef.current);
      }

      setIntervalRef.current = null;
    };
  }, [updateInterval]); // update timeRemainingRef when timeRemaining changes

  (0, _react.useEffect)(function () {
    if (timeRemaining > 0) {
      // if there is time remaining update the ref
      timeRemainingRef.current = timeRemaining;
    } else {
      // if there is no time remaining, set ref 0
      timeRemainingRef.current = 0; // clear the setInterval

      if (setIntervalRef.current !== null) {
        window.clearInterval(setIntervalRef.current);
      }
    }
  }, [timeRemaining]);
  return /*#__PURE__*/_react.default.createElement("span", null, formatTime(timeRemaining));
};

CountDown.propTypes = {
  time: _propTypes.default.number.isRequired,
  updateInterval: _propTypes.default.number
};
CountDown.displayName = 'CountDown';
var _default = CountDown;
exports.default = _default;